import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ListLayout from "../../Layout/PageLayout/ListLayout";
import SupplierPartyTable from "./SupplierPartyTable";
import { useGlobalAlert } from "../../Common/Context/GlobalAlertContext";
import { handleDelete_supplierPartyList, handleGet_supplierPartyList } from "./supplierPartyListModel";
import { useDebounce } from "../../../Utils/debounceAPI";
import { smartSearch } from "../../../MIS/Global";
import CommonPagination from "../../Common/CommonPagination/CommonPagination";
   
  
const SupplierPartyList = () => {
  const navigate = useNavigate();
  const { showAlert } = useGlobalAlert();


  const [dataList, setDataList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState({});

  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState({
    page: 1,
    limit: 100,    
  });
   
   // API
   const fetchList = async (filt) => {
    if (!filt) return;

    try {
      await handleGet_supplierPartyList({
        setLoading,
        filter: filt,
        showAlert,
        setDataList, // ✅ pass directly
        setFilteredList, // ✅ pass directly
        setTotalRecords,
        setTotalPages,
      });
    } catch (err) {
      console.error("job post fetchList error:", err);
    }
  };
  
  const debouncedFetchList = useDebounce(fetchList, 400);

  useEffect(() => {
    if (!filter) return;
    debouncedFetchList(filter); // ✅ debounce here only
  }, [filter]);

  const handleDelete=(element)=>{
    showAlert({
      title: "Confirmation",
      message: "Are you sure you want to delete this record?",
      type: "warning",
      confirmLabel: "Yes",
      cancelLabel: "No",
      onConfirm: () => {
        let data = { id: element?.id };
        handleDelete_supplierPartyList({
          setActionLoading,
          data,
          showAlert,
          setFilteredList,
          setDataList,
        });
      },
    });
  }

  const handleEdit=(element)=>{
    const data = element;
    const { created_at, updated_at, ...cleanFilter } = data;
    navigate("/admin/sup", {
      state: { ...cleanFilter },
    });
  }

  const handleSearch = (text) => {
    setSearch(text);

    const localResults = smartSearch({
      data: dataList,
      searchText: text,
      field: "search_field",
      mode: "AND", // change to OR if needed
    });

    if (localResults.length > 0) {
      setFilteredList(localResults);
    } else {
      // fallback API
      setFilter((prev) => ({
        ...prev,
        search: text,
        page: 1,
      }));
    }
  };
  return (
    <ListLayout
        title="Supplier/Party List"
        searchValue={search}
        onSearch={handleSearch}
        onClearSearch={() => handleSearch("")} 
        // onNewText="Submit"   
        // onNewLoading={submitLoading}     
        onNew={(e) => {
          navigate('/admin/sup')
        }}
        pagination={
          <CommonPagination
            page={filter.page}
            totalPages={totalPages}
            totalRecords={totalRecords}
            limit={filter.limit}
            onPageChange={(page) => setFilter((p) => ({ ...p, page }))}
            onLimitChange={(limit) =>
              setFilter((p) => ({ ...p, limit, page: 1 }))
            }
            limitStart={100}
            limitEnd={1100}
            limitStep={200}
          />
        }
         
      >
            
      <SupplierPartyTable
        data={filteredList}
        loading={loading}
        onDelete={handleDelete}
        onEdit={handleEdit}

      />

    </ListLayout>
  );
};

export default SupplierPartyList;